<template>
  <!-- 父容器：充满整个区域 -->
  <div class="table-page" style="width: 100%; height: 100vh; padding: 20px; box-sizing: border-box;">
    <a-breadcrumb>
      <a-breadcrumb-item>产品开发者</a-breadcrumb-item>
      <a-breadcrumb-item>商用案例区域分析</a-breadcrumb-item>
    </a-breadcrumb>
    <div class="title">深圳开源鸿蒙案例数据表</div>

    <!-- Element Plus 表格：充满容器、无分页、无查询 -->
    <el-table
      :data="tableData"
      border
      stripe
      fit
      height="calc(100% - 60px)"
      style="width: 100%;"
    >
      <el-table-column prop="序号" label="序号" align="center" width="80" />
      <el-table-column prop="来源" label="来源" align="center" />
      <el-table-column prop="案例设备名称" label="案例/设备名称" min-width="280" />
      <el-table-column prop="行业" label="行业" align="center" width="140" />
      <el-table-column prop="厂商单位" label="厂商（单位）" min-width="250" />
      
      <el-table-column prop="是否商用落地" label="是否商用/落地" align="center" width="140">
        <template #default="scope">
          <el-tag :type="scope.row.是否商用落地 === '否'? 'warning' : 'success'">
            {{ scope.row.是否商用落地 || '待确认' }}
          </el-tag>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script setup>
// 完整 68 条数据（已全部内置，无需外部文件）
const tableData = [

{序号:1,来源:"深圳政府官方媒体宣传案例",案例设备名称:"智开鸿银发生态体验馆（罗湖）",行业:"养老",厂商单位:"深圳市智开鸿生态科技有限公司",是否商用落地:"是"},
{序号:2,来源:"深圳政府官方媒体宣传案例",案例设备名称:"开源鸿蒙智慧康养示范场景（龙岗龙城街道）",行业:"养老",厂商单位:"深开鸿联合生态伙伴",是否商用落地:"是"},
{序号:3,来源:"深圳政府官方媒体宣传案例",案例设备名称:"罗湖区鸿蒙政务服务中心",行业:"政务",厂商单位:"罗湖区政数局等（国开鸿）",是否商用落地:"是"},
{序号:4,来源:"深圳政府官方媒体宣传案例",案例设备名称:"深圳地铁鸿蒙智慧车站",行业:"交通",厂商单位:"深圳地铁、生态合作伙伴",是否商用落地:"3个车站试点"},
{序号:5,来源:"深圳政府官方媒体宣传案例",案例设备名称:"龙岗中心医院鸿蒙智慧病区",行业:"医疗",厂商单位:"深开鸿、臻橙医疗、深圳龙岗中心医院",是否商用落地:"是"},
{序号:6,来源:"深圳政府官方媒体宣传案例",案例设备名称:"龙岗国际艺术中心-全国首个“鸿蒙剧场”",行业:"文化",厂商单位:"龙岗国际艺术中心、华为",是否商用落地:"是"},
{序号:7,来源:"深圳政府官方媒体宣传案例",案例设备名称:"平湖街道全栈国产化鸿蒙配电房",行业:"电力",厂商单位:"华睿欣能/深鹏达电网、华龙讯达、龙岗产服集团",是否商用落地:"是"},
{序号:8,来源:"深圳政府官方媒体宣传案例",案例设备名称:"龙岗区开源鸿蒙智慧泵房",行业:"水务",厂商单位:"中建三局一公司、华龙讯达（华龙工鸿操作系统）",是否商用落地:"是"},
{序号:9,来源:"深圳政府官方媒体宣传案例",案例设备名称:"龙华区章阁厂-开源鸿蒙智慧水质净化厂",行业:"水务",厂商单位:"龙华区水务部门/章阁厂",是否商用落地:"是"},
{序号:10,来源:"深圳政府官方媒体宣传案例",案例设备名称:"宝安区五指耙水厂-鸿蒙智慧水厂",行业:"水务",厂商单位:"宝安区水务部门、生态伙伴",是否商用落地:"是"},
{序号:11,来源:"深圳政府官方媒体宣传案例",案例设备名称:"“鸿蒙电子哨兵”（罗湖）",行业:"水务",厂商单位:"罗湖区相关部门",是否商用落地:"是"},
{序号:12,来源:"深圳政府官方媒体宣传案例",案例设备名称:"全国首个“鸿蒙AI数智机关”（福田）",行业:"政务",厂商单位:"福田区、深开鸿等",是否商用落地:"未落地"},
{序号:13,来源:"深圳政府官方媒体宣传案例",案例设备名称:"深圳首个“鸿蒙工地”（天安云谷三期）",行业:"建筑",厂商单位:"深圳市住建局、龙岗区住建局、天安云城投资、江苏省华建、建鸿（深圳）产业",是否商用落地:"未落地"},
{序号:14,来源:"深圳政府官方媒体宣传案例",案例设备名称:"深圳市首个全场景开源鸿蒙学校（罗湖区清水河学校）",行业:"教育",厂商单位:"罗湖区教育局、生态伙伴",是否商用落地:"未落地"},
{序号:15,来源:"兼容性产品（深圳企业）",案例设备名称:"门诊多功能医疗自助机",行业:"医疗健康",厂商单位:"深圳市证通电子股份有限公司",是否商用落地:"是（在深圳医院落地）"},
{序号:18,来源:"兼容性产品（深圳企业）",案例设备名称:"大堂式自助服务终端",行业:"金融/政务",厂商单位:"深圳市证通电子股份有限公司",是否商用落地:"是（在杭州银行落地）"},
{序号:19,来源:"兼容性产品（深圳企业）",案例设备名称:"综合柜面终端",行业:"金融/政务",厂商单位:"深圳市证通电子股份有限公司",是否商用落地:"是（在赣州银行落地）"},
{序号:23,来源:"兼容性产品（深圳企业）",案例设备名称:"住院多功能壁挂机",行业:"医疗健康",厂商单位:"深圳市证通电子股份有限公司",是否商用落地:"是（在天津医院落地）"},
{序号:21,来源:"兼容性产品（深圳企业）",案例设备名称:"多功能化验报告机",行业:"医疗健康",厂商单位:"深圳市证通电子股份有限公司",是否商用落地:"是（在天津医院落地）"},
{序号:16,来源:"兼容性产品（深圳企业）",案例设备名称:"夸父五代",行业:"机器人与自动化",厂商单位:"深圳开鸿数字产业发展有限公司",是否商用落地:"否"},
{序号:17,来源:"兼容性产品（深圳企业）",案例设备名称:"夸父五代轮臂",行业:"机器人与自动化",厂商单位:"深圳开鸿数字产业发展有限公司",是否商用落地:"否"},
{序号:20,来源:"兼容性产品（深圳企业）",案例设备名称:"AI边缘计算智能终端数据采集仪",行业:"工业物联网",厂商单位:"深圳市东深智能技术有限公司",是否商用落地:"是"},
{序号:22,来源:"兼容性产品（深圳企业）",案例设备名称:"华龙PLC8010-0010",行业:"工业物联网",厂商单位:"华龙讯达电气技术(深圳)有限公司",是否商用落地:"是"},
{序号:24,来源:"兼容性产品（深圳企业）",案例设备名称:"天鸿智能交互大屏",行业:"教育",厂商单位:"深圳鸿湖万联科技发展有限公司",是否商用落地:"是"},
{序号:25,来源:"兼容性产品（深圳企业）",案例设备名称:"在鸿工控机",行业:"工业物联网",厂商单位:"开鸿智谷（深圳）数字产业发展有限公司",是否商用落地:"是"},
{序号:26,来源:"兼容性产品（深圳企业）",案例设备名称:"雷泽智联一体机(具备计算、存储、网关功能)",行业:"工业物联网",厂商单位:"深圳中软国际科技服务有限公司",是否商用落地:"是"},
{序号:27,来源:"兼容性产品（深圳企业）",案例设备名称:"鸿略3588S平板电脑",行业:"教育",厂商单位:"深圳市中科鸿略科技有限公司",是否商用落地:"是"},
{序号:28,来源:"兼容性产品（深圳企业）",案例设备名称:"锐智一体化多功能终端设备",行业:"金融/政务",厂商单位:"深圳锐西智联科技有限公司",是否商用落地:"否"},
{序号:29,来源:"兼容性产品（深圳企业）",案例设备名称:"在鸿开发PC",行业:"PC",厂商单位:"开鸿智谷（深圳）数字产业发展有限公司",是否商用落地:"否"},
{序号:30,来源:"兼容性产品（深圳企业）",案例设备名称:"中医AI问诊机器人",行业:"医疗健康",厂商单位:"润开鸿（深圳）数字科技有限公司",是否商用落地:"否"},
{序号:31,来源:"兼容性产品（深圳企业）",案例设备名称:"12C平板",行业:"教育",厂商单位:"深圳市智微智能科技股份有限公司",是否商用落地:"是"},
{序号:32,来源:"兼容性产品（深圳企业）",案例设备名称:"开鸿Bot笔记本电脑",行业:"教育",厂商单位:"深圳开鸿数字产业发展有限公司",是否商用落地:"是"},
{序号:33,来源:"兼容性产品（深圳企业）",案例设备名称:"HH-SCDAYU802云桌面终端",行业:"软件",厂商单位:"润开鸿（深圳）数字科技有限公司",是否商用落地:"是"},
{序号:34,来源:"兼容性产品（深圳企业）",案例设备名称:"T468",行业:"交通",厂商单位:"深圳市智微智能科技股份有限公司",是否商用落地:"是"},
{序号:35,来源:"兼容性产品（深圳企业）",案例设备名称:"锐智一体化业务安全智能终端",行业:"金融/政务",厂商单位:"深圳锐西智联科技有限公司",是否商用落地:"否"},
{序号:36,来源:"兼容性产品（深圳企业）",案例设备名称:"公交智能投币车载终端",行业:"交通",厂商单位:"深圳市雄帝科技股份有限公司",是否商用落地:"是"},
{序号:37,来源:"兼容性产品（深圳企业）",案例设备名称:"HH-SCDAYU801边缘计算网关",行业:"工业物联网",厂商单位:"润开鸿（深圳）数字科技有限公司",是否商用落地:"是"},
{序号:38,来源:"兼容性产品（深圳企业）",案例设备名称:"地铁读写器",行业:"交通",厂商单位:"深圳市雄帝科技股份有限公司",是否商用落地:"否"},
{序号:39,来源:"兼容性产品（深圳企业）",案例设备名称:"鸿合智能交互大屏",行业:"教育",厂商单位:"深圳市鸿合创新信息技术有限责任公司",是否商用落地:"是"},
{序号:40,来源:"兼容性产品（深圳企业）",案例设备名称:"在鸿平板PD33",行业:"教育",厂商单位:"开鸿智谷（深圳）数字产业发展有限公司",是否商用落地:"是"},
{序号:41,来源:"兼容性产品（深圳企业）",案例设备名称:"卧位下肢康复训练机器人",行业:"医疗健康",厂商单位:"深圳市丞辉威世智能科技有限公司",是否商用落地:"是"},
{序号:42,来源:"兼容性产品（深圳企业）",案例设备名称:"新一代移动物联网终端",行业:"工业物联网",厂商单位:"深圳盈达信息科技有限公司",是否商用落地:"是"},
{序号:43,来源:"兼容性产品（深圳企业）",案例设备名称:"3568工控盒子",行业:"工业物联网",厂商单位:"深圳市视美泰技术股份有限公司",是否商用落地:"是"},
{序号:44,来源:"兼容性产品（深圳企业）",案例设备名称:"经办一体机",行业:"医疗健康",厂商单位:"深圳市德卡科技股份有限公司",是否商用落地:"否"},
{序号:45,来源:"兼容性产品（深圳企业）",案例设备名称:"车载聚合支付终端",行业:"交通",厂商单位:"深圳市雄帝科技股份有限公司",是否商用落地:"否"},
{序号:46,来源:"兼容性产品（深圳企业）",案例设备名称:"ZTOH-M61工业主机",行业:"工业物联网",厂商单位:"深圳市证开鸿科技有限公司",是否商用落地:"是"},
{序号:47,来源:"商用案例（深圳企业）",案例设备名称:"基于KaihongOS的广州地铁智慧地铁建设解决方案赋能城市轨道交通建设安全高质量",行业:"交通",厂商单位:"深圳开鸿数字产业发展有限公司",是否商用落地:"是"},
{序号:48,来源:"商用案例（深圳企业）",案例设备名称:"基于开源鸿蒙的技术底座，构建万物智联的公路机电系统",行业:"交通",厂商单位:"深圳开鸿数字产业发展有限公司",是否商用落地:"是"},
{序号:49,来源:"商用案例（深圳企业）",案例设备名称:"基于开源鸿蒙的智慧充电场站，构建智能协同生态",行业:"交通",厂商单位:"深圳开鸿数字产业发展有限公司",是否商用落地:"是"},
{序号:50,来源:"商用案例（深圳企业）",案例设备名称:"基于KaihongOS的智慧隧道项目商用标杆案例",行业:"交通",厂商单位:"深圳开鸿数字产业发展有限公司",是否商用落地:"是"},
{序号:51,来源:"商用案例（深圳企业）",案例设备名称:"中软国际携手华驰交通助力公路隧道机电数智化升级",行业:"交通",厂商单位:"深圳中软国际科技服务有限公司",是否商用落地:"是"},
{序号:52,来源:"商用案例（深圳企业）",案例设备名称:"基于OpenHarmony打造智慧油站解决方案助力油站智慧化升级",行业:"油气",厂商单位:"深圳市证通电子股份有限公司",是否商用落地:"是"},
{序号:53,来源:"商用案例（深圳企业）",案例设备名称:"基于OpenHarmony打造智慧油站产品解决方案实现油站降本增效",行业:"油气",厂商单位:"深圳证开鸿科技有限公司",是否商用落地:"是"},
{序号:54,来源:"商用案例（深圳企业）",案例设备名称:"协同创新中心,助力智慧油站智慧化升级",行业:"油气",厂商单位:"深圳市证通电子股份有限公司",是否商用落地:"是"},
{序号:55,来源:"商用案例（深圳企业）",案例设备名称:"基于OpenHarmony打造智慧校园产品解决方案助推校园数智空间融合发展",行业:"教育",厂商单位:"深圳市证开鸿科技有限公司",是否商用落地:"是"},
{序号:56,来源:"商用案例（深圳企业）",案例设备名称:"基于OpenHarmony的开源大师兄打造的人工智能开源教育解决方案",行业:"教育",厂商单位:"深圳市恩孚电子科技有限公司",是否商用落地:"是"},
{序号:57,来源:"商用案例（深圳企业）",案例设备名称:"基于OpenHarmony的智慧教室网关在智慧灯光项目的运用",行业:"教育",厂商单位:"深圳市晶讯科技股份有限公司",是否商用落地:"是"},
{序号:58,来源:"商用案例（深圳企业）",案例设备名称:"深圳技术大学基于开鸿全场景实验箱的人才培养项目",行业:"教育",厂商单位:"深圳开鸿数字产业发展有限公司",是否商用落地:"是"},
{序号:59,来源:"商用案例（深圳企业）",案例设备名称:"基于开源鸿蒙打造的智慧金融厅堂一体化解决方案",行业:"金融支付",厂商单位:"深圳市证开鸿科技有限公司",是否商用落地:"是"},
{序号:60,来源:"商用案例（深圳企业）",案例设备名称:"协同新疆银行,助力新疆加快普惠金融与数字经济高质量发展",行业:"金融支付",厂商单位:"深圳市证通电子股份有限公司",是否商用落地:"是"},
{序号:61,来源:"商用案例（深圳企业）",案例设备名称:"携手开鸿让用户操作简单，收付更放心",行业:"金融支付",厂商单位:"乙一科技（深圳）有限公司",是否商用落地:"是"},
{序号:62,来源:"商用案例（深圳企业）",案例设备名称:"鸿元智通助力湖北省警车打造警鸿智能化“移动警务作战单元”",行业:"公共安全",厂商单位:"深圳鸿元智通科技有限公司",是否商用落地:"是"},
{序号:63,来源:"商用案例（深圳企业）",案例设备名称:"携手安平伙伴，共研基于OpenHarmony的行政案件快办一体机",行业:"公共安全",厂商单位:"深圳市证通电子股份有限公司",是否商用落地:"是"},
{序号:64,来源:"商用案例（深圳企业）",案例设备名称:"与子午线共同研发基于OpenHarmony的高性能平板",行业:"公共安全",厂商单位:"江苏润开鸿数字科技有限公司",是否商用落地:"是"},
{序号:65,来源:"商用案例（深圳企业）",案例设备名称:"中软国际携手红旗智能，为新能源车主提供更加智能、高效的数字化充电体验",行业:"超高清",厂商单位:"深圳中软国际科技服务有限公司",是否商用落地:"是"},
{序号:66,来源:"商用案例（深圳企业）",案例设备名称:"动态环境监测场景的智慧解决方案",行业:"电力",厂商单位:"广东九联开鸿科技发展有限公司",是否商用落地:"是"},
{序号:67,来源:"商用案例（深圳企业）",案例设备名称:"基于KaihongOS的福州智慧多功能杆示范区打造智慧城市建设新范式",行业:"其他",厂商单位:"深圳开鸿数字产业发展有限公司",是否商用落地:"是"},
{序号:68,来源:"商用案例（深圳企业）",案例设备名称:"基于KaihongOS的福州城乡建总智慧大厦让建筑成为可进化的智慧“有机生命体”",行业:"其他",厂商单位:"深圳开鸿数字产业发展有限公司",是否商用落地:"是"},

]
</script>

<style scoped>
.title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 16px;
  color: #333;
}
</style>